import { v4 as uuid } from 'uuid';
import { ACCORDION_NODE_NAME, ACCORDION_PANEL_NODE_NAME } from '../../editor/extensions/accordion';
import { AccordionBlock, ContentBlockType } from '../../model';
import { BlockToTiptapConverter, convertBlocksToTiptapNodes, ConverterContext } from '../blocks-to-tiptap.converter';
import { convertTiptapNodesToBlocks, TiptapToBlockConverter } from '../tiptap-to-blocks.converter';

/**
 * Converts an AccordionBlock to TipTap accordion + accordionPanel nodes.
 * Recursively converts nested content blocks within each panel.
 */
export const convertAccordionBlockToTiptap = ((block, context?: ConverterContext) => {
  return {
    type: ACCORDION_NODE_NAME,
    attrs: {
      ...(block.custom_css && { custom_css: block.custom_css }),
      ...(block.custom_style && { custom_style: block.custom_style }),
    },
    content: block.panels.map((panel) => ({
      type: ACCORDION_PANEL_NODE_NAME,
      attrs: {
        title: panel.title,
        ...(panel.icon && { icon: panel.icon }),
      },
      content: panel.content.length ? convertBlocksToTiptapNodes(panel.content, context) : [{ type: 'paragraph' }],
    })),
  };
}) satisfies BlockToTiptapConverter<AccordionBlock>;

/**
 * Converts a TipTap accordion node back to an AccordionBlock.
 * Recursively converts nested content within each panel.
 */
export const convertTiptapToAccordionBlock = ((json, context?) => {
  const attrs = json.attrs ?? {};
  const panelNodes = (json.content ?? []).filter((n) => n.type === ACCORDION_PANEL_NODE_NAME);

  return {
    id: uuid(),
    type: ContentBlockType.Accordion,
    ...(attrs['custom_css'] && { custom_css: attrs['custom_css'] as string }),
    ...(attrs['custom_style'] && { custom_style: attrs['custom_style'] as Record<string, string> }),
    panels: panelNodes.map((panelNode) => {
      const icon = panelNode.attrs?.['icon'] as string | undefined;
      return {
        title: (panelNode.attrs?.['title'] as string) ?? '',
        ...(icon && { icon }),
        content: panelNode.content?.length ? convertTiptapNodesToBlocks(panelNode.content, context) : [],
      };
    }),
  };
}) satisfies TiptapToBlockConverter;
